import React, {useEffect} from "react";
import {Button, Input, Row, Select, Space, Table} from "antd";
import axios from "axios";
import {getUsersResponse} from "../../../types/admin";
import {useCredentialStore} from "../../../hooks/useCredentialsStore";
import {useNavigate} from "react-router-dom";

export const MessagingPage = () => {

    const navigate = useNavigate();

    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const [flag, setFlag] = React.useState(false)

    const {token} = useCredentialStore(({token}) => ({token}));

    const [loading, setLoading] = React.useState(false);

    const [selectedUserId, setSelectedUserId] = React.useState();

    const [taskList, setTaskList] = React.useState<any>([]);

    const [currentPage, setCurrentPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [totalElements, setTotalElements] = React.useState(0);

    const [dropDownValue, setDropDownValue] = React.useState("all");

    const [sortDirection, setSortDirection] = React.useState<"asc" | "desc">("asc");

    const [searchText, setSearchText] = React.useState("")

    const onGetAllMessageTask = () => {

        let url = `/api/message?page=${currentPage}&pageSize=${pageSize}`

        axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                const userList: getUsersResponse = res.data;
                setTaskList(userList.data);
                setTotalElements(userList.totalElements);
                setFlag(!flag)
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handlePauseClick = (id: string) => {

        let url = `/api/message/${id}/pause`

        axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                onGetAllMessageTask()
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleResumeClick = (id: string) => {

        let url = `/api/message/${id}/resume`

        axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                onGetAllMessageTask()
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDeleteClick = (id: string) => {

        let url = `/api/message/${id}`

        axios.delete(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                onGetAllMessageTask()
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const columns = [
        {
            title: "No.",
            dataIndex: "index",
            key: 'index',
            render: (text: string, record: any, index: number) => {
                return (currentPage) * pageSize + index + 1
            }
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text: any, record: any) => {
                return (
                    <Space direction={"horizontal"}>
                        {
                            record.status === 'ACTIVE' ? <Button onClick={() => {
                                handlePauseClick(record.id)
                            }}>Pause</Button> : <Button
                                onClick={() => {
                                    handleResumeClick(record.id)
                                }}
                            >Resume</Button>
                        }
                        <Button onClick={() => {
                            navigate(`/admin/messaging/details/${record.id}`)
                        }}>Details</Button>
                        <Button
                            onClick={() => {
                                handleDeleteClick(record.id)
                            }}
                        >
                            Delete
                        </Button>
                    </Space>
                )
            }
        }
    ];

    useEffect(() => {
        onGetAllMessageTask()
    }, [currentPage, pageSize, searchText])

    return (
        <Space direction={"vertical"} style={{width: '100%'}}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span className='page-title'>Messaging</span>
                <div>
                                            <span onClick={() => {
                                                navigate(`/admin/messaging/new`, {replace: false});
                                            }} style={{
                                                backgroundColor: "#39B64B",
                                                padding: "5px 15px",
                                                cursor: "pointer",
                                                color: "white",
                                                borderRadius: 7,
                                                display: "inline-block",
                                                textTransform: "uppercase",
                                                marginRight: 10
                                            }}>
                                                + New Message
                        </span>

                </div>

            </div>


            <Table
                dataSource={taskList}
                columns={columns}
                pagination={{
                    total: totalElements,
                    showSizeChanger: true,
                    onChange: (page, pageSize) => {
                        setCurrentPage(page - 1);
                        setPageSize(pageSize);
                        setFlag(!flag);
                    }
                }}
            />
        </Space>
    )
}
